import { v4 as uuidv4 } from "uuid";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITraCuuDiemReducer, ITraCuuDiemSinhVienReducer } from "../../reducer-model/tra-cuu-diem/ITraCuuDiemReducer";
import { ITraCuuDiemActionsType } from "../../action-types/tra-cuu-diem/ITraCuuDiemActionsType";

const iniTab : ITraCuuDiemSinhVienReducer = {
    id:  uuidv4(),
    title: "undefined",
    status: eReducerStatusBase.is_not_initialization,
    traCuuDiem: {
        traCuuDiemThanhPhanList: [],
        traCuuDiemThiList: [],
        traCuuDiemThanhPhanThiList: [],
        traCuuDiemLopHocPhanList: [],
        traCuuDiemPhongThiList: [],
    },
   
}

const iniState: ITraCuuDiemReducer = {
    selectedId: iniTab.id,
    sinhViens: [iniTab],
    isHienThiBangThanhPhan: false,
};

export const traCuuDiemReducer = (state : ITraCuuDiemReducer = iniState, action: ITraCuuDiemActionsType): ITraCuuDiemReducer => {
    switch (action.type) {
        case "TRA_CUU_DIEM_ADD_NEW_TAB": {
            const newTab: ITraCuuDiemSinhVienReducer = {
                ...iniTab,
                id: uuidv4(),
                title: action.payload?.ho_ten ?? "Untitled",
            };
            return {
                ...state,
                sinhViens: [...state.sinhViens, newTab],
            };
        }
        case "TRA_CUU_DIEM_CHANGE_SELECTED_TAB": {
            return {
                ...state,
                selectedId: action.payload,
            };
        }
        case "TRA_CUU_DIEM_REMOVE_TAB": {
            const newSinhViens = state.sinhViens.filter((tab) => tab.id !== action.payload);
            return {
                ...state,
                sinhViens: newSinhViens,
                selectedId: newSinhViens.length > 0 ? newSinhViens[0].id : iniTab.id,
            };
        }
        case "TRA_CUU_DIEM_UPDATE_TAB_DATA": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === action.payload.id) {
                    return {
                        ...tab,
                        ...action.payload,
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_LOAD_TRA_CUU_DIEM_START": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === state.selectedId) {
                    return {
                        ...tab,
                        status: eReducerStatusBase.is_loading,
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_LOAD_TRA_CUU_DIEM_SUCCESS": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === state.selectedId) {
                    return {
                        ...tab,
                        status: eReducerStatusBase.is_completed,
                        traCuuDiem: action.payload.data,
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_LOAD_TRA_CUU_DIEM_ERROR": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === state.selectedId) {
                    return {
                        ...tab,
                        status: eReducerStatusBase.is_completed,
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_CHANGE_SELECTED_DIEM_THI": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === state.selectedId) {
                    return {
                        ...tab,
                        selected_id_diem_thi: action.payload.data,
                        selected_id_diem: undefined, // Reset selected diem when changing diem thi
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_CHANGE_SELECTED_DIEM": {
            const updatedSinhViens = state.sinhViens.map((tab) => {
                if (tab.id === state.selectedId) {
                    return {
                        ...tab,
                        selected_id_diem: action.payload.data,
                        selected_id_diem_thi: undefined, // Reset selected diem thi when changing diem
                    };
                }
                return tab;
            });
            return {
                ...state,
                sinhViens: updatedSinhViens,
            };
        }
        case "TRA_CUU_DIEM_CHANGE_IS_HIEN_THI_BANG_THANH_PHAN": {
            return {
                ...state,
                isHienThiBangThanhPhan: action.payload,
            };
        }
        default:
            return state;
       
    }
}